<script>
	import thumb_EnSqxtCIZ6o from '$lib/Components/Youtube/images/EnSqxtCIZ6o.jpg?w=610';
	import thumb_Hm9csxMvffU from '$lib/Components/Youtube/images/Hm9csxMvffU.jpg?w=610';

	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ScrollNav from '$lib/Components/ScrollNav/ScrollNav.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import headerBackground from './images/LP-Mullion_Guide-01.jpg';
	import hBar from './images/LP-Mullion_Guide-02.svg';
	import fBar from './images/LP-Mullion_Guide-03.svg';
	import colorOptions from './images/LP-Mullion_Guide-04.jpg';
	import tapeMeasure from './images/LP-Mullion_Guide-05.jpg';
	import markingMiddle from './images/LP-Mullion_Guide-06.jpg';
	import drillingLBracket from './images/LP-Mullion_Guide-07.jpg';
	import horizontalSplitA from './images/LP-Mullion_Guide-09a1.svg';
	import horizontalSplitB from './images/LP-Mullion_Guide-09a2.svg';
	import horizontalSplitC from './images/LP-Mullion_Guide-09a3.svg';
	import brackInstallA from './images/LP-Mullion_Guide-12.jpg';
	import brackInstallB from './images/LP-Mullion_Guide-13.jpg';
	import brackInstallC from './images/LP-Mullion_Guide-14.jpg';
	import verticalSplitA from './images/LP-Mullion_Guide-15a1.svg';
	import verticalSplitB from './images/LP-Mullion_Guide-15a2.svg';
	import verticalSplitC from './images/LP-Mullion_Guide-15a3.svg';
	import threePanelSplit from './images/LP-Mullion_Guide-18.svg';
	import modiScreenshotLeft from './images/MBI-left.jpg';
	import modiScreenshotLower from './images/MBI-lower.jpg';
	import modiScreenshotRight from './images/MBI-right.jpg';
	import modiScreenshotUpper from './images/MBI-upper.jpg';

	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
</script>

<Section
	backgroundImage={headerBackground}
	backgroundColor="blue"
	loading="eager"
	class="
   max-md:-mt-32
   md:min-h-[clamp(20rem,66dvh,33dvw)]
 "
>
	<h1
		class="
    self-center
    max-md:mt-8
  "
	>
		A Guide To Installing Mullions For Your Indow Window Inserts
	</h1>
</Section>
<Section backgroundColor="grey-light">
	<p>
		A mullion divides a window into smaller units. An Indow mullion comes in an
		<strong class="text-indow-blue">‘H’</strong> profile to divide our window
		insert into more manageable units when needed. The acrylic inserts slide
		into the white space of the <strong class="text-indow-blue">‘H’</strong>.
	</p>
	<p>
		Sometimes a specialty <strong class="text-indow-blue">‘F’</strong> profile mullion
		is needed for windows that meet at an inside corner, like a fish tank. If this
		is the case for your windows, let us know so we can provide different instructions.
	</p>
</Section>

<ScrollNav>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#intro-to-mullions" class="scrollactive-item">Intro To Mullions</a>
	</li>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#horizontal-mullion-installation" class="scrollactive-item"
			>Horizontal Mullion Installation</a
		>
	</li>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#horizontal-mullion-measurement" class="scrollactive-item"
			>Horizontal Mullion Measurement</a
		>
	</li>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#vertical-mullion-installation" class="scrollactive-item"
			>Vertical Mullion Installation</a
		>
	</li>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#vertical-mullion-measurement" class="scrollactive-item"
			>Vertical Mullion Measurement</a
		>
	</li>
	<li>
		<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
		<a href="#three-panel-split" class="scrollactive-item">3 Panel Split</a>
	</li>
</ScrollNav>

<Section backgroundColor="white" id="intro-to-mullions">
	<h2>Consider the Indow Mullion when:</h2>
	<ul>
		<li>
			<p>
				Your window, or the opening you’d like to seal, is too large for a
				standard Indow insert.
			</p>
		</li>
		<li>
			<p>
				You will be installing & removing your insert often—for cleaning or
				opening your window.
			</p>
		</li>
		<li>
			<p>
				You want to open part of your window while keeping part of the insert
				installed.
			</p>
		</li>
		<li>
			<p>
				Your existing window has frame dividers & you want your insert to match.
			</p>
		</li>
	</ul>
	<p>
		The Indow Mullion comes in the same colors as our insert frames - white,
		brown, & black - but can be painted to match your window frame. The <strong
			class="text-indow-blue">‘F’</strong
		> bar is only available in a “mill” finished aluminum.
	</p>
	<Bubble>
		<h3>The Indow Mullion includes everything you need for installation:</h3>
		<ul class="grid">
			<li>
				<p><strong class="text-indow-blue">‘H’</strong> Bar</p>
			</li>
			<li>
				<p>Mounting <strong class="text-indow-blue">‘L’</strong> Brackets</p>
			</li>
			<li>
				<p>Screws</p>
			</li>
		</ul>
	</Bubble>
	<p>
		Please let us know if you did not receive the mullion sample piece with the
		mountings brackets and screws.
	</p>
	<div
		class="
    grid gap-x-8 gap-y-16
    md:grid-cols-3
  "
	>
		<div class="h-full w-auto">
			<h3>H Bar</h3>
			<Image src={hBar} class="w-full" />
		</div>
		<div
			class="
     h-full w-auto place-content-start place-items-start justify-items-start
   "
		>
			<h3>F Bar</h3>
			<Image src={fBar} class="w-full" />
		</div>
		<div class="h-full w-auto">
			<h3>Color Options</h3>
			<Image src={colorOptions} class="w-full" />
		</div>
	</div>
	<p>
		<strong>NOTE:</strong> This guide includes instructions for installing
		brackets, measuring with only the brackets in place, and installation once
		inserts and mullion have been delivered. For alternate installation
		techniques or when using
		<strong class="text-indow-blue">‘F’</strong> bars, you will need to completely
		install the bar and hardware before measuring.
	</p>
</Section>

<Section backgroundColor="white" id="horizontal-mullion-installation">
	<h2>Horizontal Split Installation</h2>
	<Bubble>
		<h3>What you will need:</h3>
		<ul class="grid grid-cols-2 gap-x-4">
			<li>
				<p>2 <strong class="text-indow-blue">‘L’</strong> brackets</p>
			</li>
			<li>
				<p>2 Screws per bracket</p>
			</li>
			<li>
				<p>Drill with 1/16" Drill Bit</p>
			</li>
			<li>
				<p>#1 Phillips Bit Screwdriver</p>
			</li>
			<li>
				<p>Pencil</p>
			</li>
			<li>
				<p>Tape Measure</p>
			</li>

			<li>
				<p>Laser Measuring Device</p>
			</li>
		</ul>
	</Bubble>

	<h3>Bracket Installation</h3>
	<ol class="list-decimal">
		<li>
			<p>
				Determine placement of the window split. We recommend using an existing
				visual line, like a window frame, sash or divide, if present.
			</p>
		</li>
		<li>
			<p>
				Measure from the bottom of the frame up to the point at which the
				mullion is desired and mark the frame with a pencil.**
			</p>
			<Image
				src={tapeMeasure}
				alt="Measuring for bracket position"
				class="w-full"
			/>
		</li>
		<li>
			<p>Repeat on the other side.</p>
		</li>
		<li>
			<p>
				Position an <strong class="text-indow-blue">‘L’</strong> bracket so that your
				pencil mark is at the TOP of the bracket and mark a center point for each
				counter sunk hole.
			</p>
			<Image
				src={markingMiddle}
				alt="Marking drill holes for L bracket"
				class="w-full"
			/>
		</li>
		<li>
			<p>Repeat for the other side.</p>
		</li>
		<li>
			<p>Pre-drill each marked center point.</p>
		</li>
		<li>
			<p>
				Once holes are drilled on both sides, secure the <strong
					class="text-indow-blue">‘L’</strong
				> brackets with the screws provided.
			</p>
			<Image
				src={drillingLBracket}
				alt="Drilling holes for L bracket"
				class="w-full"
			/>
		</li>
	</ol>
	<p>
		<strong>NOTE:</strong> MAKE SURE you position the bracket at the correct depth
		(& frame step) within the frame. If you aren’t sure what a frame step is, walk
		your fingers from the surface of your window out toward your wall. Every time
		you have to take a step with your finger, that’s a frame step.
	</p>
</Section>
<Section backgroundColor="blue">
	<h2>Watch the Video:</h2>
	<p>“How to Measure Your Window for Mullions and Indow Inserts”</p>
	<Youtube posterImageSrc={thumb_EnSqxtCIZ6o} videoId="EnSqxtCIZ6o" />
</Section>

<Section backgroundColor="white" id="horizontal-mullion-measurement">
	<h2>Horizontal Split Measurement</h2>
	<ol class="list-decimal">
		<li>
			<p>
				Follow the instructions included with your Laser Measure Kit to capture
				the six measurements for each opening.
			</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						When measuring the <strong class="text-indow-blue">“A”</strong>
						value for the bottom panel, place the laser tool just below the
						<strong class="text-indow-blue">‘L’</strong> bracket and shoot straight
						across the window frame.
					</p>
				</li>
			</ol>
			<div class="grid grid-cols-3 gap-4">
				<Image
					src={horizontalSplitA}
					alt="Horizontal split measurement diagram A"
					class="w-full"
				/>
				<Image
					src={horizontalSplitB}
					alt="Horizontal split measurement diagram B"
					class="w-full"
				/>
				<Image
					src={horizontalSplitC}
					alt="Horizontal split measurement diagram C"
					class="w-full"
				/>
			</div>
			<p class="w-full text-center">
				The blue <strong class="text-indow-blue">‘L’</strong> bar represents the
				Mounting <strong class="text-indow-blue">‘L’</strong> Brackets
			</p>
		</li>
		<li>
			<p>
				Double check your measurements. The <strong class="text-indow-blue"
					>‘B’</strong
				>
				value for the upper insert should be nearly the same as the
				<strong class="text-indow-blue">‘A’</strong> value for the lower insert.
			</p>
		</li>
		<li>
			<p>Enter all data into the Measure by Indow portal, check, and save.</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						When entering your measure data into the Measure by Indow portal,
						designate <strong>UPPER”</strong> or <strong>“LOWER”</strong> in the Location
						field. This will be labeled on each insert so you know the correct location
						to install each panel.
					</p>
				</li>
			</ol>

			<div class="grid grid-cols-2 gap-4">
				<Image src={modiScreenshotUpper} class="w-full" />
				<Image src={modiScreenshotLower} class="w-full" />
			</div>
		</li>
	</ol>
	<h3>Insert Installation</h3>
	<ol class="list-decimal">
		<li>
			<p>Receive and un-package insert packaging.</p>
		</li>
		<li>
			<p>
				If the mullion bar was not ordered pre-cut, you will need to measure the
				opening and cut it now.
			</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						Measure the distance across the frame at the specific location the
						mullion will be installed.
					</p>
				</li>
				<li>
					<p>
						Measure and cut the aluminum bar using any saw with a metal-cutting
						blade.
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				Lay the mullion in place on top of the previously installed brackets.
			</p>
		</li>
		<li>
			<p>Install the Indow inserts.</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						Install the TOP insert FIRST to compress the mullion down on top of
						the <strong class="text-indow-blue">‘L’</strong> brackets.
					</p>
				</li>
				<li>
					<p>
						When installing the bottom/lower insert, install the TOP of the
						panel first, so it nests in the channel of the mullion.
					</p>
				</li>
			</ol>
		</li>
	</ol>
</Section>

<Section backgroundColor="white" id="vertical-mullion-installation">
	<h2>Vertical Split Installation</h2>
	<p>
		A vertical split is when the <strong class="text-indow-blue">‘H’</strong>
		bar is on its side. Imagine the <strong class="text-indow-blue">‘H’</strong>
		tipped over 90 degrees and both the inserts sliding in from the side.
	</p>
	<Bubble>
		<h3>What you will need:</h3>
		<ul class="grid grid-cols-2 gap-x-4">
			<li><p>4 ‘L’ Brackets</p></li>
			<li><p>2 Screws per Bracket</p></li>
			<li><p>Drill with 1/16” Drill Bit</p></li>
			<li><p>#1 Phillips Bit Screwdriver</p></li>
			<li><p>Pencil</p></li>
			<li><p>Tape Measure</p></li>
			<li><p>Laser Measuring Device</p></li>
			<li><p>Mullion Sample (provided by Indow)</p></li>
		</ul>
	</Bubble>
	<Youtube posterImageSrc={thumb_Hm9csxMvffU} videoId="Hm9csxMvffU" />
	<h3>Bracket Installation</h3>
	<p>
		For a vertical installation, you will need to install two sets of ‘L’
		brackets on either side of the mullion to hold it firmly in place.
	</p>
	<ol class="list-decimal">
		<li>
			<p>
				Determine placement of the window split. We recommend using an existing
				visual line, like a window frame, sash or other divide, if available.
			</p>
		</li>
		<li>
			<p>
				On the window frame header, measure from the left of the frame to the
				point at which the mullion divider is desired and mark the frame with a
				pencil.**
			</p>
		</li>
		<li><p>Repeat on the bottom of the window sill.</p></li>
		<li>
			<p>
				Position an ‘L’ bracket in the top of the frame so that your pencil mark
				is at the RIGHT of the bracket and mark a center point for each counter
				sunk hole.
			</p>
		</li>
		<li><p>Repeat on the bottom of the frame.</p></li>
		<li><p>Pre-drill each marked center point.</p></li>
		<li>
			<p>
				Once holes are drilled on top and bottom, secure the <strong
					class="text-indow-blue">‘L’</strong
				> brackets with the screws provided.
			</p>
		</li>
		<li>
			<p>
				On the bottom of the window frame, place the mullion sample against the
				installed <strong class="text-indow-blue">‘L’</strong> bracket.
			</p>
			<Image
				src={brackInstallA}
				alt="Placing mullion sample against installed bracket"
				class="w-full"
			/>
		</li>
		<li>
			<p>
				Place the other loose bracket inside the mullion channel and mark the
				location of the hole in the bracket.
			</p>
		</li>
		<li>
			<p>
				Remove the mullion divider and pre-drill marked center point and secure <strong
					class="text-indow-blue">‘L’</strong
				> bracket in place with the screws provided.
			</p>
			<Image
				src={brackInstallB}
				alt="Marking and drilling for top bracket"
				class="w-full"
			/>
		</li>
		<li>
			<p>Repeat steps 8-10 for the top of the window frame.</p>
		</li>
	</ol>
	<p>
		**MAKE SURE you position the bracket at the correct depth or frame step
		within the frame.
	</p>
</Section>

<Section backgroundColor="white" id="vertical-mullion-measurement">
	<h2>Vertical Split Measurement</h2>
	<ol class="list-decimal">
		<li>
			<p>
				Follow the instructions included with your Laser Measure Kit to capture
				the six measurements for each opening.
			</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						When measuring the <strong class="text-indow-blue">‘D’</strong>
						value of the left panel and the
						<strong class="text-indow-blue">‘C’</strong>
						value of the right panel, ensure your laser tool is flush against the
						window frame, not resting on the
						<strong class="text-indow-blue">‘L’</strong> bracket, and shooting straight
						up to the top of the window frame. These values should nearly be the same.
					</p>
				</li>
			</ol>
			<div class="grid grid-cols-3 gap-4">
				<Image
					src={verticalSplitA}
					alt="Vertical split measurement diagram A"
					class="w-full"
				/>
				<Image
					src={verticalSplitB}
					alt="Vertical split measurement diagram B"
					class="w-full"
				/>
				<Image
					src={verticalSplitC}
					alt="Vertical split measurement diagram C"
					class="w-full"
				/>
			</div>
		</li>
		<li>
			<p>Enter all data into the Measure by Indow (MBI) portal.</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						When entering your measure data into the MBI portal, designate
						<strong>“LEFT”</strong> or <strong>“RIGHT”</strong> in the Location field.
						This will be labeled on each insert so you know the correct location to
						install each panel.
					</p>
				</li>
			</ol>
			<div class="grid grid-cols-2 gap-4">
				<Image
					src={modiScreenshotLeft}
					alt="Measure by Indow portal - product and frame details"
					class="w-full"
				/>
				<Image
					src={modiScreenshotRight}
					alt="Measure by Indow portal - product and frame details"
					class="w-full"
				/>
			</div>
		</li>
	</ol>
</Section>

<Section backgroundColor="white" id="three-panel-split">
	<h2>3 Panel Splits</h2>
	<p>
		If you have a large window opening requiring 2+ mullion bars, you will need
		to place additional brackets in the window, in the places you wish to
		install the mullions. Where you measure from will be important as it can
		impact the outcome of your inserts. Here is a diagram illustrating our
		recommended measurements in a 3 panel split:
	</p>
	<Image src={threePanelSplit} alt="3 panel split diagram" class="w-full" />
	<ul
		class="
    list-none
    [&_li_h3]:text-left
  "
	>
		<li>
			<h3 class="text-[#00b0f0]">BLUE</h3>
			<p>Heights measured on the frame, next to the brackets.</p>
		</li>
		<li>
			<h3 class="text-[#77c14f]">GREEN</h3>
			<p>Diagonals from the bracket to the frame.</p>
		</li>
		<li>
			<h3 class="text-[#b2572f]">BROWN</h3>
			<p>Widths from the bracket to the frame.</p>
		</li>
		<li>
			<h3 class="text-[#ff0000]">RED</h3>
			<p>Downward diagonals, from the bracket to the frame.</p>
		</li>
		<li>
			<h3 class="text-[#f89734]">ORANGE</h3>
			<p>Heights measured on the frame, next to the brackets.</p>
		</li>
		<li>
			<h3 class="text-[#893b93]">PURPLE</h3>
			<p>Widths from bracket to bracket.</p>
		</li>
		<li>
			<h3 class="text-[#ffd527]">YELLOW</h3>
			<p>
				Diagonals measured from <strong class="text-indow-blue">‘L’</strong>
				brackets into <strong class="text-indow-blue">‘L’</strong> brackets.
			</p>
		</li>
	</ul>
	<h3>Insert Installation</h3>
	<ol class="list-decimal">
		<li>
			<p>
				Once you’ve received your inserts and mullion bar, unpackage the panels
				to identify which should be installed to the left of the mullion and
				which should be installed to the right.
			</p>
		</li>
		<li>
			<p>If the mullion bar was not ordered pre-cut, measure and cut it now.</p>
			<ol class="list-[lower-alpha]">
				<li>
					<p>
						Measure the distance across the frame at the specific location the
						mullion will be installed.
					</p>
				</li>
				<li>
					<p>
						Apply that measurement to the aluminum bar. Cut it with any saw with
						a metal-cutting blade.
					</p>
				</li>
			</ol>
		</li>
		<li>
			<p>
				Place the <strong class="text-indow-blue">‘H’</strong> bar against the
				previously installed brackets so one set of brackets is nested in the
				<strong class="text-indow-blue">‘H’</strong> channel.
			</p>
		</li>
		<li>
			<p>
				Position the second top bracket so the pre-drilled hole is properly
				aligned, and secure into place.
			</p>
		</li>
		<li>
			<p>Repeat on the bottom.</p>
		</li>
		<li>
			<p>
				Install the Indow inserts, taking care to install the side that will be
				nested in the mullion first.
			</p>
		</li>
	</ol>
	<p>
		For alternate installation techniques or different mullion profiles, you
		will need to completely install the bar and hardware before measuring.
	</p>
	<Image
		src={brackInstallC}
		alt="Insert installation into mullion"
		class="w-full"
	/>
</Section>

<GetAFreeEstimate />
<Reviews />
